<template>
    <div class="navigation">
        <div class="navigation-container" :class="{'moveElement' : toggleClass}" :style="{'z-index': setIndex}">
            <div class="navigation-menu-left" >
                <div id="nav-mobile" class="menu-mobile" @click="toggleNav()">
                    <div class="bar1"></div>
                    <div class="bar2"></div>
                    <div class="bar3"></div>
                </div>
                <div class="menu-tabs">
                    <div class="menu-tabs-item">
                        <router-link :to="{name: 'building'}" exact class="menu-tabs-item--text"  @click.native="hideLayers()">Building</router-link>
                    </div>
                    <div class="menu-tabs-item">
                        <router-link :to="{name: 'residences'}" exact class="menu-tabs-item--text"  @click.native="hideLayers()">Residences</router-link>
                    </div>
                    <div class="menu-tabs-item">
                        <router-link :to="{name: 'penthouse'}" exact class="menu-tabs-item--text"  @click.native="hideLayers()">Penthouse</router-link>
                    </div>
                    <div class="menu-tabs-item">
                        <router-link :to="{name: 'neighborhood'}" exact class="menu-tabs-item--text" @click.native="hideLayers()">Neighborhood</router-link>
                    </div>
                    <div class="menu-tabs-item">
                        <a  class="menu-tabs-item--text" @click="showLayer('showAvailability')">Availability</a>
                    </div>
                    <div class="menu-tabs-item">
                        <router-link :to="{name: 'team'}" exact class="menu-tabs-item--text"  @click.native="hideLayers()">Team</router-link>
                    </div>
                    <div class="menu-tabs-item">
                        <a  class="menu-tabs-item--text" @click="showLayer('showContact')">Contact</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="navigation-menu-right" :class="{'moveElement' : toggleClass}">
            <span class="navigation-menu-right--text" :style="{visibility: isPass}">
              <img src="../assets/logo.svg" alt="Logo" >
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Navigation",
        props: {
          logoPosition: {
            default: true,
            required: false,
          },
          toggleClass: {
            default: false,
            required: false
          },
          isPass: {
            default: null,
            required: false
          },
          setIndex: {
            default: null,
            required: false
          }
        },
        data: () => ({
          mobileNavigation: false,
          screenWidth: null,
          showMobileNavigation: false,
          addBackground: false
        }),
        created() {
          this.checkScreeWidth()
          window.addEventListener('resize', this.checkScreeWidth )
        },
        watch: {
            toggleClass: function(newVal) {
                if(!newVal) {
                    const element = document.getElementById("nav-mobile");
                    element.classList.remove("change");
                    element.classList.add("menu-mobile");
                    this.showMobileNavigation = false
                    this.$emit('toggleMobileNavigation', this.showMobileNavigation)
                }
            }
        },
        methods: {
            checkScreeWidth() {
                this.screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                const screenHeight = (window.innerHeight > 0) ? window.innerHeight : screen.height;
                if(this.screenWidth < 601 && screenHeight < 831) {
                    this.mobileNavigation = true
                }
            },
            toggleNav() {
                const element = document.getElementById("nav-mobile");
                element.classList.toggle("change");
                //element.classList.toggle("menu-mobile");
                this.showMobileNavigation = !this.showMobileNavigation;
                if(this.showMobileNavigation) {
                    document.documentElement.style.overflow = "hidden";
                } else {
                    document.documentElement.style.overflow = "auto";
                }
                this.$emit('toggleMobileNavigation', this.showMobileNavigation)
            },
              showLayer(value) {
                this.$emit('showLayer', value)
              },
              hideLayers() {
                this.$emit('hideLayers', true)
              }
        }
    }
</script>

<style scoped>

</style>
